import { render, staticRenderFns } from "./component.html?vue&type=template&id=224496b1&scoped=true&external"
import script from "./component.vue?vue&type=script&lang=js"
export * from "./component.vue?vue&type=script&lang=js"
import style0 from "./component.scss?vue&type=style&index=0&id=224496b1&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224496b1",
  null
  
)

export default component.exports